import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { agentAxiosObj } from "../../../config/apiClients";
import { queryParams } from "../../../utils/interface";
import { ClientWithDrawalsState } from "../../types";

const initialState: ClientWithDrawalsState = {
  isLoading: false,
  clientsWithdrawals: [],
  pagination: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false
  }
}

export const getAllWithDrawals = createAsyncThunk(
  "/withdraw/getAll",
  async ({ paramPage, paramLimit, search, startDate, endDate }: queryParams, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();

      if (startDate) params.append("startDate", startDate as string);
      if (endDate) params.append("endDate", endDate as string);
      if (search) params.append("search", search);
      if (paramPage) params.append("paramPage", String(paramPage));
      if (paramLimit) params.append("paramLimit", String(paramLimit));

      const response = await agentAxiosObj.get(
        `/withdrawals${params.toString() ? `?${params.toString()}` : ""}`);
      return response.data
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Requests' });
    }
  }
)

const agentWithDrawalsSlice = createSlice({
  name: "agentWithDrawals",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllWithDrawals.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllWithDrawals.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientsWithdrawals = action.payload.payload.clientsWithdrawals;
        state.pagination = {
          totalItems: action.payload.payload.totalItems,
          currentPage: action.payload.payload.page,
          totalPages: action.payload.payload.totalPages,
          hasNextPage: action.payload.payload.hasNextPage
        };
      })
      .addCase(getAllWithDrawals.rejected, (state) => {
        state.isLoading = false;
        state.clientsWithdrawals = []
      })
  }
})

export default agentWithDrawalsSlice.reducer;